import React from "react";
import style from "./navInstitutional.module.scss";

interface InstitutionalProps {
    children?: any;
}

export const InstitutionalNav: React.FC<InstitutionalProps> = ({
    children,
}) => {
    return (
        <div className={style.nav}>
            <ul className={style.nav__list_option}>
                <li className={style.nav__list_item}>
                    <a href="https://www.superbid.net/como-comprar"> Como Comprar</a>
                       </li>
                <li className={style.nav__list_item}>
                   <a href="https://www.superbid.net/quero-vender">
                        Quero Vender
                    </a>
                </li>

                <li className={style.nav__list_item}>
                   <a href="https://blog.superbid.net/?utm_source=blog&utm_medium=sitesuperbid&utm_campaign=home&_ga=2.140898235.860380888.1631536747-139058670.1630275648">
                        Blog
                    </a>
                </li>
                <li className={style.nav__list_item}>
                   <a href="https://www.superbid.net/ajuda">Ajuda</a>
                </li>
                <li className={style.nav__list_item}>
                   <a href="https://www.superbid.net/fale-conosco">
                        Fale Conosco
                    </a>
                </li>
            </ul>
        </div>
    );
};
